import type { IPublicUser } from '@sravni/types/lib/auth';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_FINGER_PRINT_VALUE } from '../../constants/fingerPrint';
import { IReviewUser } from '../../interfaces/reviews';

export interface IUser extends IPublicUser {
  family_name?: string;
  birthdate?: string;
}

export type IState = {
  loggedIn: boolean;
  account?: IUser;
  fp: string;
  info: IReviewUser;
};

const initialState: IState = {
  loggedIn: false,
  fp: DEFAULT_FINGER_PRINT_VALUE,
  info: {} as IReviewUser,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<IUser>) => {
      state.loggedIn = true;
      state.account = payload;
    },
    setUserInfo: (state, { payload }: PayloadAction<IReviewUser>) => {
      state.info = payload;
    },
    destroyUser: () => initialState,
    setFingerprint: (state, { payload }: PayloadAction<string>) => {
      state.fp = payload;
    },
  },
});

const { actions, reducer } = userSlice;

export const { setUser, setUserInfo, destroyUser, setFingerprint } = actions;

export default reducer;
